import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Location } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-download-app',
    templateUrl: './download-app.component.html',
    styleUrls: ['./download-app.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class DownloadAppComponent {

    public showQrCode: boolean = false;
    public innerWidth: number = 0;

    constructor(
        private router: Router,
        private location: Location) { }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        this.updateQrVisibility();
    }

    @HostListener('window:resize', ['$event'])
    onResize(): void {
        this.innerWidth = window.innerWidth;
        this.updateQrVisibility();
    }

    private updateQrVisibility(): void {
        // Show QR code only on desktop widths
        this.showQrCode = this.innerWidth > 768;
    }

    goBack(): void {
        this.location.back();
    }

    downloadIOS(): void {
        window.open(environment.appStoreUrl, '_blank');
    }

    downloadAndroid(): void {
        window.open(environment.playStoreUrl, '_blank');
    }


}
